import List from "./List";
import Create from "./Create";
import Edit from "./Edit";

export const SelectionCreate = Create;
export const SelectionList = List;
export const SelectionEdit = Edit;
